var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', {
    staticClass: "custom-card"
  }, [_c('div', {
    staticClass: "card-layout",
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('card-inner-layout', {
    attrs: {
      "header-text": _vm.cardProjectName,
      "name-text": _vm.cardEventName
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_vm.icons ? _c('event-icon', {
          attrs: {
            "event-type": _vm.item.type
          }
        }) : _c('img', {
          attrs: {
            "src": require("@/assets/event/icon/light/sheet.svg"),
            "alt": "Sheet icon"
          }
        })];
      },
      proxy: true
    }, _vm.item.description ? {
      key: "description",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.item.description) + " ")];
      },
      proxy: true
    } : null, {
      key: "date",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.displayDate) + " ")];
      },
      proxy: true
    }], null, true)
  })], 1), _vm.icons ? _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "settings-area",
    attrs: {
      "id": `settings${_vm.item.id}`,
      "tabindex": "0"
    }
  }, [_c('img', {
    staticClass: "pb-3",
    attrs: {
      "src": require("@/assets/dashboard/settings.svg"),
      "alt": "Settings icon"
    }
  })]), _c('b-popover', {
    attrs: {
      "target": `settings${_vm.item.id}`,
      "triggers": "focus",
      "placement": "bottomleft"
    }
  }, [_c('div', {
    staticClass: "popover-wrapper"
  }, [_c('div', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: `update-modal-${_vm.item.id}`,
      expression: "`update-modal-${item.id}`"
    }],
    staticClass: "mx-auto mb-2 mt-1"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/dashboard/edit-icon.svg"),
      "alt": "Edit icon"
    }
  }), _c('span', [_vm._v(" " + _vm._s(_vm.$t('dashboard.events.settings.edit')) + " ")])]), _c('div', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: `duplicate-modal-${_vm.item.id}`,
      expression: "`duplicate-modal-${item.id}`"
    }],
    staticClass: "mx-auto mb-2 mt-1"
  }, [_c('font-awesome-icon', {
    staticClass: "icon",
    attrs: {
      "icon": "copy"
    }
  }), _c('span', [_vm._v(" " + _vm._s(_vm.$t('dashboard.events.settings.duplicate')) + " ")])], 1), _vm.item.role === 'ADMINISTRATOR' ? _c('div', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: `delete-modal-${_vm.item.id}`,
      expression: "`delete-modal-${item.id}`"
    }],
    staticClass: "delete"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/dashboard/trash-icon.svg"),
      "alt": "Delete icon"
    }
  }), _c('span', [_vm._v(" " + _vm._s(_vm.$t('dashboard.events.settings.delete')) + " ")])]) : _vm._e()])]), _c('custom-modal', {
    attrs: {
      "id": `update-modal-${_vm.item.id}`,
      "title": _vm.$t('dashboard.events.form.update-title')
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('create-event-modal', {
          attrs: {
            "mode": "update",
            "item": _vm.item
          },
          on: {
            "success": _vm.onUpdateSuccess,
            "close": function ($event) {
              return _vm.onClose('update', _vm.item.id);
            }
          }
        })];
      },
      proxy: true
    }], null, false, 800624690)
  }), _c('custom-modal', {
    attrs: {
      "id": `duplicate-modal-${_vm.item.id}`,
      "title": _vm.$t('dashboard.events.form.duplicate-title')
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('create-event-modal', {
          attrs: {
            "mode": "duplicate",
            "item": _vm.item
          },
          on: {
            "success": _vm.onDuplicateSuccess,
            "close": function ($event) {
              return _vm.onClose('duplicate', _vm.item.id);
            }
          }
        })];
      },
      proxy: true
    }], null, false, 972511572)
  }), _c('confirmation-modal', {
    attrs: {
      "id": `delete-modal-${_vm.item.id}`,
      "variant": "danger",
      "yes-key": "dashboard.events.delete.ok"
    },
    on: {
      "on-click-yes": _vm.deleteEvent
    },
    scopedSlots: _vm._u([{
      key: "body-text",
      fn: function () {
        return [_c('img', {
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/customer-project/danger.svg")
          }
        }), _c('h2', {
          staticClass: "modal-title"
        }, [_vm._v(" " + _vm._s(_vm.$t('dashboard.events.delete.title')) + " ")]), _c('p', {
          staticClass: "modal-p"
        }, [_vm._v(" " + _vm._s(_vm.$t('dashboard.events.delete.body')) + " ")])];
      },
      proxy: true
    }], null, false, 421672649)
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }